import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import API from "../base/API";
import Auth from "../auth/Auth";
import { translate } from '../base/Translation';
import TranslationForm from "./TranslationForm";

export default class TranslationEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_translation: "/translation/save/:translation",
			get_translation: "/translation/fetch/:translation"
		});

		this.state = {
			translation: null,
		}
	}

	fetchData() {
		this.api.request({
			route: "get_translation",
			params: { translation: this.props.params.translationID },
			success: (response) => {
				this.setState({ translation: response });
			}
		});
	}

	saveData() {
		this.api.request({
			route: "save_translation",
			params: { translation: this.props.params.translationID },
			data: this.state.translation,
			created: (response) => {
				browserHistory.push("/translations");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onChange(evt) {
		let translation = this.state.translation;

		translation[evt.target.name] = evt.target.value;

		this.setState({ translation });
	}

	render() {

		if (this.state.translation === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={this.state.translation.original} />
				<PageBody>
					<TranslationForm data={this.state.translation} onSave={this.saveData.bind(this)} onChange={this.onChange.bind(this)} />
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/translation/TranslationEdit.js